import { render, staticRenderFns } from "./textfield-familyattribute-name.vue?vue&type=template&id=acf96748"
import script from "./textfield-familyattribute-name.vue?vue&type=script&lang=js"
export * from "./textfield-familyattribute-name.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports